<template>
    <div>
        <van-cell-group name="userCard" title="实名认证">
            <van-field v-model="user.userName" placeholder="请输入您的姓名"/>
            <van-field v-model="user.userCard" placeholder="请输入您的身份证号码"/>
        </van-cell-group>

        <van-cell-group name="userPhone" title="手机号码">
            <van-field v-model="user.userPhone" placeholder="请输入您的手机号码"/>
        </van-cell-group>

        <van-cell-group name="userAddress" title="我的地址">
            <van-field disabled v-model="user.userAddress" placeholder="请选择您的地址" @click="showAreaPop = true"/>
        </van-cell-group>

        <van-cell-group name="userEmail" title="我的邮箱">
            <van-field v-model="user.userEmail" placeholder="请输入您的邮箱"/>
        </van-cell-group>

        <van-button round type="info" color="linear-gradient(to right, #4587DD, #40B6F8)"
                    style="margin: 50px 10%; width: 80%;"
                    @click="save">保 存
        </van-button>

        <van-popup v-model="showAreaPop" position="bottom">
            <div>
                <van-area :area-list="areaList" @cancel="showAreaPop = false" @confirm="areaConfirm" @change="areaChange"/>
            </div>
        </van-popup>
    </div>
</template>

<script>

    import Vue from 'vue';
    import {Button, Cell, CellGroup, Field, Area, Popup} from 'vant';
    import areaData from '@/utils/area.js'

    Vue.use(Button).use(Cell).use(CellGroup).use(Field).use(Area).use(Popup);

    export default {
        name: "EditProfile",
        data() {
            return {
                areaList: areaData,
                showAreaPop: false,
                user: {},
            }
        },
        created() {
            this.user = { ...this.$store.state.user.user};
        },
        methods: {
            areaChange(picker,values,index) {
                this.user.province = values[0].name
                this.user.city = values[1].name
                this.user.area = values[2].name
                this.$set(this.user,'userAddress',`${this.user.province} ${this.user.city} ${this.user.area}`)
            },
            areaConfirm(values,index) {
                this.user.province = values[0].name
                this.user.city = values[1].name
                this.user.area = values[2].name
                this.$set(this.user,'userAddress',`${this.user.province} ${this.user.city} ${this.user.area}`)
                this.showAreaPop = false
            },
            save() {
                this.$axios.post("/user/profile", this.user).then(res => {
                    if (res.code == 200) {
                        this.$store.dispatch('UpdateUserInfo', this.user)
                        this.$router.back()
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
